import { FormattedMessage, useIntl } from 'react-intl';
import Button from '@rio-cloud/rio-uikit/Button';
import ClearableInput from '@rio-cloud/rio-uikit/ClearableInput';

interface VehicleSearchBarProps {
    search: string;
    onSearchChange: (value: string) => void;
    totalCount: number;
}

const VehicleSearchBar = ({ search, onSearchChange, totalCount }: VehicleSearchBarProps) => {
    const intl = useIntl();
    return (
        <div className="panel panel-default margin-bottom-0">
            <div className="panel-body">
                <div className="display-flex align-items-center justify-content-between">
                    <div className="display-flex align-items-center gap-10">
                        <span className="uikit-icon icon-truck text-size-20 text-color-gray" />
                        <div>
                            <div className="text-bold text-size-14">
                                <FormattedMessage id="intl-msg:vehicleSearch.title" />
                            </div>
                            <div className="text-size-11 text-color-gray text-uppercase">
                                <FormattedMessage
                                    id="intl-msg:vehicleSearch.activeUnits"
                                    values={{ count: totalCount }}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ width: 280 }}>
                        <ClearableInput
                            placeholder={intl.formatMessage({ id: 'intl-msg:vehicleSearch.placeholder' })}
                            value={search}
                            onChange={onSearchChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VehicleSearchBar;
